import { actionTypes, createDate, deepCopy } from '@morawadigital/skynet-framework'
import { getDefaultDateRange } from '../util'
import { AVAILABLE_REFEREES_SORT_BY_OPTION_NAME } from '../util/constants'
import { SET_AVAILABLE_REFEREES_TOOLS_VALUES, SET_DATE_RANGE, SET_DIVISIONS, SET_EVALUATION_GAME_FILTER_QUERY, SET_FILTER_LEAGUE_TYPE, SET_INVOICE_MANAGEMENT_FILTER_QUERY, SET_LEAGUES_FILTER_QUERY, SET_NOTIFICATION_GAME_FILTER_QUERY, SET_REGIONS, SET_RELEASE_GAME_FILTER_QUERY, SET_SCHEDULE_GAME_FILTER_QUERY, SET_SCHEDULE_LOCAL_CHANGES, SET_USERS_FILTER_DATE, SET_USERS_FILTER_QUERY, TOGGLE_ALTERNATIVE_SCHEDULE_LAYOUT_IS_ENABLED, TOGGLE_DISPLAY_NOT_SHOW_BY_DEFAULT_REFEREES_IS_ENABLED, TOGGLE_DIVISION_DISPLAY_IS_ENABLED, TOGGLE_SCHEDULE_HEADER_IS_HIDDEN } from './constants'
import { getCustomer } from '../util/customer'

const initialStateLocalChanges = {

    schedule: {},

}

const initialStateUi = {

    alternativeScheduleLayoutIsEnabled:       getCustomer().enableAlternativeScheduleLayoutByDefault,
    availableRefereesFilterName:              '',
    availableRefereesFilterZipCode:           '',
    availableRefereesSortBy:                  AVAILABLE_REFEREES_SORT_BY_OPTION_NAME,
    dateRangeFrom:                            getDefaultDateRange().from,
    dateRangeFromInvoiceManagement:           getDefaultDateRange( true ).from,
    dateRangeFromPublic:                      getDefaultDateRange().from,
    dateRangeTo:                              getDefaultDateRange().to,
    dateRangeToFromInvoiceManagement:         getDefaultDateRange( true ).to,
    dateRangeToPublic:                        getDefaultDateRange().to,
    displayNotShowByDefaultRefereesIsEnabled: false,
    divisionDisplayIsEnabled:                 false,
    divisions:                                [],
    divisionsPublic:                          [],
    evaluationGameFilterQuery:                '',
    filterLeagueType:                         '',
    invoiceManagementFilterQuery:             '',
    leaguesFilterQuery:                       '',
    notificationGameFilterQuery:              '',
    regions:                                  [],
    releaseGameFilterQuery:                   '',
    scheduleGameFilterQuery:                  '',
    scheduleHeaderIsHidden:                   false,
    usersFilterDate:                          createDate(),
    usersFilterQuery:                         '',

}

export const localChanges = ( state = initialStateLocalChanges, action ) => {

    switch ( action.type ) {

        case actionTypes.LOGOUT: {

            return initialStateLocalChanges

        }

        case SET_SCHEDULE_LOCAL_CHANGES: {

            return { ...state, schedule: deepCopy( action.payload.localChanges ) }

        }

        default:

            return state

    }

}

export const ui = ( state = initialStateUi, action ) => {

    switch ( action.type ) {

        case actionTypes.LOGOUT: {

            return {

                ...state,

                alternativeScheduleLayoutIsEnabled:       initialStateUi.alternativeScheduleLayoutIsEnabled,
                availableRefereesFilterName:              initialStateUi.availableRefereesFilterName,
                availableRefereesFilterZipCode:           initialStateUi.availableRefereesFilterZipCode,
                availableRefereesSortBy:                  initialStateUi.availableRefereesSortBy,
                dateRangeFrom:                            initialStateUi.dateRangeFrom,
                dateRangeFromInvoiceManagement:           initialStateUi.dateRangeFromInvoiceManagement,
                dateRangeTo:                              initialStateUi.dateRangeTo,
                dateRangeToFromInvoiceManagement:         initialStateUi.dateRangeToFromInvoiceManagement,
                displayNotShowByDefaultRefereesIsEnabled: initialStateUi.displayNotShowByDefaultRefereesIsEnabled,
                divisions:                                initialStateUi.divisions,
                evaluationGameFilterQuery:               initialStateUi.evaluationGameFilterQuery,
                filterLeagueType:                         initialStateUi.filterLeagueType,
                invoiceManagementFilterQuery:             initialStateUi.invoiceManagementFilterQuery,
                leaguesFilterQuery:                       initialStateUi.leaguesFilterQuery,
                notificationGameFilterQuery:              initialStateUi.notificationGameFilterQuery,
                regions:                                  initialStateUi.regions,
                releaseGameFilterQuery:                   initialStateUi.releaseGameFilterQuery,
                scheduleGameFilterQuery:                  initialStateUi.scheduleGameFilterQuery,
                scheduleHeaderIsHidden:                   initialStateUi.scheduleHeaderIsHidden,
                usersFilterDate:                          initialStateUi.usersFilterDate,
                usersFilterQuery:                         initialStateUi.usersFilterQuery,

            }

        }

        case SET_AVAILABLE_REFEREES_TOOLS_VALUES: {

            return { ...state, availableRefereesFilterName: action.payload.filterName, availableRefereesFilterZipCode: action.payload.filterZipCode, availableRefereesSortBy: action.payload.sortBy }

        }

        case SET_DATE_RANGE: {

            return { ...state, [ action.payload.keyFrom ]: action.payload.from, [ action.payload.keyTo ]: action.payload.to }

        }

        case SET_DIVISIONS: {

            return { ...state, [ action.payload.key ]: action.payload.divisions }

        }

        case SET_EVALUATION_GAME_FILTER_QUERY: {

            return { ...state, evaluationGameFilterQuery: action.payload.filterQuery }

        }

        case SET_FILTER_LEAGUE_TYPE: {

            return { ...state, filterLeagueType: action.payload.filterLeagueType }

        }

        case SET_INVOICE_MANAGEMENT_FILTER_QUERY: {

            return { ...state, invoiceManagementFilterQuery: action.payload.filterQuery }

        }

        case SET_LEAGUES_FILTER_QUERY: {

            return { ...state, leaguesFilterQuery: action.payload.filterQuery }

        }

        case SET_NOTIFICATION_GAME_FILTER_QUERY: {

            return { ...state, notificationGameFilterQuery: action.payload.filterQuery }

        }

        case SET_REGIONS: {

            return { ...state, regions: action.payload.regions }

        }

        case SET_RELEASE_GAME_FILTER_QUERY: {

            return { ...state, releaseGameFilterQuery: action.payload.filterQuery }

        }

        case SET_SCHEDULE_GAME_FILTER_QUERY: {

            return { ...state, scheduleGameFilterQuery: action.payload.filterQuery }

        }

        case SET_USERS_FILTER_DATE: {

            return { ...state, usersFilterDate: action.payload.filterDate }

        }

        case SET_USERS_FILTER_QUERY: {

            return { ...state, usersFilterQuery: action.payload.filterQuery }

        }

        case TOGGLE_ALTERNATIVE_SCHEDULE_LAYOUT_IS_ENABLED: {

            return { ...state, alternativeScheduleLayoutIsEnabled: action.payload.isEnabled }

        }

        case TOGGLE_DISPLAY_NOT_SHOW_BY_DEFAULT_REFEREES_IS_ENABLED: {

            return { ...state, displayNotShowByDefaultRefereesIsEnabled: action.payload.isEnabled }

        }

        case TOGGLE_DIVISION_DISPLAY_IS_ENABLED: {

            return { ...state, divisionDisplayIsEnabled: action.payload.isEnabled }

        }

        case TOGGLE_SCHEDULE_HEADER_IS_HIDDEN: {

            return { ...state, scheduleHeaderIsHidden: action.payload.isHidden }

        }

        default:

            return state

    }

}